#import "./account-fragment.graphql"
#import "./contact-fragment.graphql"
#import "./lead-fragment.graphql"

fragment SubmissionFragment on Submission {
    id
    submissionTime
    submissionUrl
    booking {
        id
        additionalAttendees {
            id
            emailAddresses {
                primary {
                    isPrimary
                    value {
                        address
                        display
                        formatted
                    }
                }
            }
        }
    }
    primaryEntity {
        ... on Account {
            ...AccountFragment
        }
        ... on Contact {
            ...ContactFragment
        }
        ... on Lead {
            ...LeadFragment
        }
    }
    formVersion {
        id
        form {
            id
            name
            htmlUrlPath
        }
    }
    fields {
        edges {
            node {
                id
                label
                isRequired
            }
            fieldValue {
                ... on FormFieldSubmissionValueSubfields {
                    subfieldValues {
                        name
                        value
                        label
                    }
                }
                ... on FormFieldSubmissionValueMultiple {
                    values
                }

                ... on FormFieldSubmissionValueSingle {
                    value
                }
            }
        }
    }
}
